import { validationCodes } from '../../constants'
import { IAppState, IFormControl } from '../../types'
import { calculateAge } from '../allHelpers'

export const executeUiValidation = (
	ctrl: IFormControl,
	appState: IAppState,
) => {
	const control = ctrl

	if (!Array.isArray(control.validations)) return

	for (let i = 0; i < control.validations.length; i += 1) {
		// stop on first validation
		if (!control.isValid) return

		const validation = control.validations[i]
		let isValid = true
		switch (validation.code) {
			case validationCodes.mustBeGreater:
				// ssn age is controled by this validation rule too, but it is implemented as a specific validation
				isValid =
					control.controlName.toLocaleLowerCase().indexOf('ssn') > -1
						? true
						: Number(control.value) > Number(validation.value)

				// As of yet, only support for YEAR comparison in regards to datePicker
				isValid =
					control.type === 'datePicker'
						? Number(calculateAge(control.value)) >
							Number(validation.value)
						: isValid
				break

			case validationCodes.mustBeGreaterOrEqual:
				// no special treatment of ssn or datepicker controls as of yet - implement if/when we need it
				isValid = Number(control.value) >= Number(validation.value)
				break

			case validationCodes.mustBeLess:
				// ssn age is controled by this validation rule too, but it is implemented as a specific validation
				isValid =
					control.controlName.toLocaleLowerCase().indexOf('ssn') > -1
						? true
						: Number(control.value) < Number(validation.value)

				// As of yet, only support for YEAR comparison in regards to datePicker
				isValid =
					control.type === 'datePicker'
						? Number(calculateAge(control.value)) <
							Number(validation.value)
						: isValid
				break

			case validationCodes.mustBeLessOrEqual:
				// no special treatment of ssn or datepicker controls as of yet - implement if/when we need it
				isValid = Number(control.value) <= Number(validation.value)
				break

			// Important note on checking for backslash character with RegEx when passed here with .json (as we do)
			// You need to use four consecutive backslashes in order to check for 1 occurrence, because the first two render the backslash as the escape character,
			// and then two more to render the actual backslash to look for, however of course when it being a backslash it need to be escaped, hence 2 + 2 backslashes: \\\\
			// Working usage is the applicant.address.street field in personalDataFormSettings.json
			case validationCodes.mustMatchPattern:
				isValid = new RegExp(String(validation.value)).test(
					String(control.value),
				)
				break

			case validationCodes.mustMatch:
				isValid =
					control.value ===
					appState.controlsState[String(validation.value)].value
				break

			case validationCodes.mustNotMatch:
				isValid =
					control.value !==
					appState.controlsState[String(validation.value)].value
				break

			case validationCodes.mustBeGreaterOtherControl:
				isValid =
					control.value >
					appState.controlsState[String(validation.value)].value
				break

			case validationCodes.mustBeLessOtherControl:
				isValid =
					control.value <
					appState.controlsState[String(validation.value)].value
				break

			default:
				break
		}

		control.isValid = isValid
		control.validationMessage = isValid ? '' : validation.message
	}
}
